<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<span class="int_type mgr_5">
					<select v-model="outstanding_yn" class="tbl_select sm_int">
						<!-- <option v-for="codeType in sortedCodeTypes" v-bind:value="codeType.value" v-bind:key="codeType.value">{{ codeType.text }}</option> -->
						<option value="Y">Outstadning Only</option>
						<option value="N">Show All Invoice</option>
					</select>
				</span>
				<em class="lt_text">Invoice Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="invoice_date_from"/> ~ <CustomDatePicker v-model="invoice_date_to"/></span>

				<label for="bounce_check" style="margin-right:5px;"><input type="checkbox" @change="search()" v-model="bounce_check" id="bounce_check" />B.C.</label>

				<em class="lt_text">Sales Group</em>
				<span class="int_type_no_border mgr_5"><CodeSelect className="tbl_select" :codes="salesGroups" v-model="sales_group_code"/></span>

				<span class="int_type_no_border mgr_5"> <PartnerSelect ref="bill_to_code" v-model="bill_to_code" ph="Bill To" :showName="false" :initialName="bill_to_name" :nameWidth="200" @set-partner="setPartner" /> </span>

				<em class="lt_text">Elapsed Days</em>
				<span class="int_type_no_border mgr_5">
					<select class="tbl_select" v-model="elapsed_days">
						<option :value="null">None</option>
						<option :value="31">Under 30 Days</option>
						<option :value="61">31-60 Days</option>
						<option :value="91">61-90 Days</option>
						<option :value="121">91-120 Days</option>
						<option :value="151">121-150 Days</option>
						<option :value="181">151-180 Days</option>
						<option :value="211">Over 180 Days</option>
					</select>
				</span>

				<span class="int_type sm_int mgr_5">
					<input type="text" v-model.trim="keyword" placeholder="Enter Search Keyword" autofocus autocomplete="off" @keyup.enter="search()" />
				</span>

				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>

		<table class="list_tbl" v-columns-resizable>
			<thead>
				<tr>
					<th width="2%"></th>
					<th width="6.5%">Inv. No</th>
					<th width="2%">Type</th>
					<th width="5%">Inv. Date</th>
					<th width="6.5%">S/O No</th>
					<th width="5%">S/O Date</th>
					<th width="5%">Bill To Code</th>
					<th width="10%">Bill To Name</th>
					<th width="5%">Ship To<br />State</th>
					<th width="6%">Sales Group</th>
					<th width="6%">Payment<br />Term</th>
					<th width="4%">Past Due<br />Date</th>
					<th width="6%">Inv. Amt.</th>
					<th width="6%">Balance</th>
					<th width="6%">Elapsed Days</th>
					<th width="3%"><input type="checkbox" @change="selectAll()" v-model="allSelected" /></th>
					<th width="6%">Pay Amt.</th>
					<th width="10%">Info.(Bounce, SC & etc.)</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="invoice in invoices" v-bind:key="invoice.invoice_no">
					<td><input type="radio" v-if="invoice.invoice_type == 'B'" v-model="selected_bc_invoice_no" :value="invoice.invoice_no" /></td>
					<td class="al_left truncate">
						<a href="javascript:;" @click="selectInvoice(invoice)">
							<font :color="invoice.urgent_yn == 'Y' ? 'red' : 'black'">{{ invoice.invoice_dn }}</font>
						</a>
					</td>
					<td class="al_center">{{ invoice.invoice_type }}</td>
					<td class="al_left">{{ invoice.invoice_date }}</td>
					<td class="al_left truncate">
						<a href="javascript:;" @click="selectSO(invoice)">
							<font :color="invoice.urgent_yn == 'Y' ? 'red' : 'black'">{{ invoice.so_dn }}</font>
						</a>
					</td>
					<td class="al_left">{{ invoice.so_date }}</td>
					<td class="al_left truncate">
						<a href="javascript:;" @click="gotoPartner(invoice.bill_to_code)">{{ invoice.bill_to_code }}</a>
					</td>
					<td class="al_left truncate">
						<a href="javascript:;" @click="gotoPartner(invoice.bill_to_code)" :title="invoice.bill_to_name">{{ invoice.bill_to_name }}</a>
					</td>
					<td class="al_left truncate">{{ invoice.ship_to_state }}</td>
					<td class="al_left truncate" :title="invoice.sales_group_name">{{ invoice.sales_group_name }}</td>
					<td class="al_left truncate" :title="invoice.payment_term_name">{{ invoice.payment_term_name }}</td>
					<td class="al_right">{{ invoice.past_due_date | commaSeparated }}</td>
					<td class="al_right">{{ invoice.invoice_amount | toCurrency }}</td>
					<td class="al_right">{{ invoice.balance | toCurrency }}</td>
					<td class="al_left">
						<span v-if="invoice.elapsed_days < 31">Under 30</span>
						<span v-else-if="invoice.elapsed_days < 61">31 - 60</span>
						<span v-else-if="invoice.elapsed_days < 91">61 - 90</span>
						<span v-else-if="invoice.elapsed_days < 121">91 - 120</span>
						<span v-else-if="invoice.elapsed_days < 151">121 - 150</span>
						<span v-else-if="invoice.elapsed_days < 181">151 - 180</span>
						<span v-else>Over 180</span>
					</td>
					<!-- <td class="al_center"><input type="checkbox" v-model="invoice.selected" :disabled="invoice.balance == 0" @change="selectCheckBox(invoice)" /></td> -->
					<td class="al_center"><input type="checkbox" v-model="invoice.selected" :disabled="invoice.balance == 0 && user.company_id != 'newjigu'" @change="selectCheckBox(invoice)" /></td>
					<td class="al_right">
						<!-- <currency-input type="text" v-model.trim="invoice.pay_amount" :disabled="invoice.balance == 0" :precision="2" class="r_int long_type al_right" @input="inputPayAmount(invoice)" @focus="$event.target.select()" /> -->
						<currency-input
							type="text"
							v-model.trim="invoice.pay_amount"
							:disabled="invoice.balance == 0 && user.company_id != 'newjigu'"
							:precision="2"
							class="r_int long_type al_right"
							@input="inputPayAmount(invoice)"
							@focus="$event.target.select()"
						/>
					</td>
					<td class="al_left">
						{{ invoice.bounce_invoice_info }}
						<span v-if="invoice.invoice_type == 'A'">{{ invoice.remark }}</span>
						<span v-if="invoice.invoice_type == 'B'"> / {{ invoice.remark }}</span>

						<span v-if="user.company_id == 'newjigu' && invoice.ar_memo"> {{ invoice.ar_memo }}</span>
					</td>
				</tr>
				<tr>
					<td colspan="16" class="al_right">
						Received Amount: <currency-input type="text" v-model.trim="received_amount" style="width:6em;" :precision="2" class="r_int long_type al_right" @blur="blurReceivedAmount()" @input="inputReceivedAmount()" />,
						<font color="red">Pay Amount Sum</font>
					</td>

					<td class="al_right">
						<currency-input type="text" v-model.trim="pay_amount_sum" :disabled="true" :precision="2" class="r_int long_type al_right" readonly />
					</td>
					<td></td>
				</tr>
				<!-- <tr>
					<td colspan="9" class="al_right"><font color="red">Total</font></td>

					<td class="al_right">
						<font color="red">{{ total_amount_sum | toCurrency }}</font>
					</td>
					<td></td>
					<td></td>
				</tr> -->
			</tbody>
		</table>
		<div style="text-align:right;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

		<Paging v-show="paging_yn == 'Y'" ref="paging" v-on:gotoPage="gotoPage"></Paging>

		<div class="bottom_bt_box">
			<ul>
				<li v-if="selected_bc_invoice_no"><a href="javascript:;" class="gray_bt mgr_15" @click="waive()">Waive Fee</a></li>
				<!-- <template v-if="user.company_id != 'beautyplus'"> -->
				<!-- <a v-if="invoice.bill_to_code && arHistoryAccessible" href="javascript:;" type="button" class="search_bt" @click="gotoArHistory(invoice.bill_to_code, invoice.bill_to_name)">AR History</a> -->
				<li><a href="javascript:;" class="gray_bt mgr_15" @click="excel()">Excel</a></li>
				<li><a href="javascript:;" class="gray_bt mgr_15" @click="gotoArHistory()">AR History</a></li>
				<li v-if="modifiable && cart_yn == 'N'"><a href="javascript:;" class="gray_bt" @click="addCart()">Add To Cart</a></li>
				<li v-if="modifiable && cart_yn == 'N'"><a href="javascript:;" class="gray_bt mgr_10" @click="viewCart()">View Cart</a></li>
				<li v-if="modifiable && cart_yn == 'Y'"><a href="javascript:;" class="gray_bt" @click="removeCart('N')">Remove</a></li>
				<li v-if="modifiable && cart_yn == 'Y'"><a href="javascript:;" class="gray_bt mgr_10" @click="removeCart('Y')">Remove All</a></li>
				<!-- </template> -->
				<!-- <li>Default Date : <CustomDatePicker v-model="invoice_date_from" /></li> -->
				<li v-if="modifiable"><a href="javascript:;" class="gray_bt" @click="processPayment()">Process Payment</a></li>
			</ul>
		</div>

		<Modal @close="closeModal" v-if="showModal" :draggable="false">
			<template slot="title">Process Payment</template>
			<template slot="body">
				<ReceiptPopup :toReceiveInvoices="toReceiveInvoices" :totalReceiptAmount="pay_amount_sum" v-on:close="closeModal()" @receipt-call-back="receiptCallBack" />
			</template>
		</Modal>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiIndex, apiSelectArList, apiAddCart, apiRemoveCart } from '@/api/receipt/index.js';
import { apiWaiveInvoice } from '@/api/sales/invoice.js';
import { defaultDataType } from 'export-xlsx';
import { exportDataExcel } from '@/api/util';
import Paging from '@/components/common/Paging';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import CodeSelect from '@/components/common/CodeSelect';
import PartnerSelect from '@/components/common/PartnerSelect';
import { daysAgo } from '@/utils/date.js';
import ReceiptPopup from '@/components/common/ReceiptPopup';
import Modal from '@/components/common/Modal';

export default {
	data: function() {
		return {
			uri: null,
			backUri: '/',
			paging_yn: 'Y',
			page_size: 25,
			page_no: 1,
			list_count: 0,

			invoice_date_from: null,
			invoice_date_to: null,
			sales_group_code: null,
			bill_to_code: null,
			bill_to_name: null,
			outstanding_yn: 'Y',
			cart_yn: 'N',
			bounce_check: false,
			selected_bc_invoice_no: null,

			keyword: null,

			allSelected: false,

			salesGroups: [],

			invoices: [],
			toReceiveInvoices: [],
			received_amount: null,
			pay_amount_sum: null,

			modalName: '',
			showModal: false,

			elapsed_days: null,
			saveParam: {},
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		selectedInvoices: function() {
			return this.invoices.filter(invoice => invoice.selected);
		},
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		// toReceiveInvoices: function() {
		// 	return this.invoices.filter(invoice => invoice.selected && invoice.pay_amount);
		// },
	},
	// computed: {
	// 	pay_amount_sum: {
	// 		get: function() {
	// 			var sum = 0;
	// 			this.invoices.forEach(function(invoice) {
	// 				if (invoice.selected) {
	// 					console.log(invoice.pay_amount);
	// 					sum += invoice.pay_amount;
	// 				}
	// 			});
	// 			return sum;
	// 		},
	// 		set: function(newValue) {},
	// 	},
	// },
	components: {
		CustomDatePicker,
		Paging,
		CodeSelect,
		PartnerSelect,
		ReceiptPopup,
		Modal,
	},
	methods: {
		async gotoArHistory() {
			var partner_name = null;
			if (this.bill_to_code) partner_name = this.bill_to_name;
			let routeData = this.$router.resolve({ name: 'arHistory', query: { backUri: this.uri, bill_to_code: this.bill_to_code, bill_to_name: partner_name } });
			window.open(routeData.href, 'herp_ar_history');

			//this.$router.push({ name: 'arHistory', query: { backUri: this.$route.fullPath, bill_to_code: partner_code, bill_to_name: partner_name, date_type_is_invoice: '1', all_date: '1' } });
			/*
			let routeData = this.$router.resolve({ name: 'arHistory', query: { backUri: this.$route.fullPath, bill_to_code: partner_code, bill_to_name: partner_name, date_type_is_invoice: '1', all_date: '1' } });
			window.open(routeData.href, '_blank'); */
		},
		waive() {
			//console.log(this.selected_bc_invoice_no);
			this.$alertify.confirm('Are you sure to waive the fee?', () => {
				this.waiveConfirm();
			});
		},
		async waiveConfirm() {
			const { data } = await apiWaiveInvoice({
				invoice_no: this.selected_bc_invoice_no,
			});

			if (data.result) {
				this.$toast.success('Waived successfully');
				this.search();
			} else {
				this.$toast.error(data.msg);
			}
		},
		processPayment() {
			var vm = this;
			this.toReceiveInvoices = [];
			this.invoices.forEach(function(invoice) {
				//if (invoice.selected && invoice.pay_amount) {
				if (invoice.selected) {
					vm.toReceiveInvoices.push(invoice);
				}
			});
			//console.log(this.toReceiveInvoices);
			if (this.toReceiveInvoices.length == 0) {
				this.$toast.error('Nothing to process');
				return;
			} /* else if (this.user.company_id == 'beautyplus' && this.toReceiveInvoices.length > 1) {
				this.$toast.error('2 or more invoices were selected.');
				return;
			} */
			//console.log('received amount', this.received_amount);

			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		receiptCallBack(result) {
			if (result) {
				this.selectArs();

				if (this.user.company_id == 'newjigu') this.$refs.bill_to_code.$refs.keyword.focus();
			}
		},
		async addCart() {
			if (this.selectedInvoices.length == 0) {
				this.$toast.error('Nothing to add');
				return;
			} //console.log('received amount', this.received_amount);

			var ar_cart = [];
			this.selectedInvoices.forEach(function(invoice) {
				ar_cart.push(invoice.invoice_no);
			});

			const { data } = await apiAddCart({
				ar_cart: ar_cart,
			});

			if (data.result) {
				this.$toast.success('Added to cart successfully');
			} else {
				this.$toast.error(data.msg);
			}
		},
		async removeCart(remove_all_yn) {
			if (remove_all_yn == 'N' && this.selectedInvoices.length == 0) {
				this.$toast.error('Nothing to remove');
				return;
			} //console.log('received amount', this.received_amount);

			var ar_cart = [];
			this.selectedInvoices.forEach(function(invoice) {
				ar_cart.push(invoice.invoice_no);
			});

			const { data } = await apiRemoveCart({
				ar_cart: ar_cart,
				remove_all_yn: remove_all_yn,
			});

			if (data.result) {
				this.$toast.success('Removed from cart successfully');
				this.selectArs();
			} else {
				this.$toast.error(data.msg);
			}
		},
		viewCart() {
			this.cart_yn = 'Y';
			this.selectArs();
		},
		calPayAmount() {
			var vm = this;
			this.pay_amount_sum = 0;
			this.invoices.forEach(function(invoice) {
				if (invoice.selected) {
					//console.log(invoice.pay_amount);
					vm.pay_amount_sum += invoice.pay_amount;
				}
			});
		},
		selectCheckBox(invoice) {
			//console.log(invoice.selected, invoice.balance);
			if (invoice.selected) invoice.pay_amount = invoice.balance;
			else invoice.pay_amount = null;

			this.calPayAmount();
		},
		inputPayAmount(invoice) {
			if (invoice.pay_amount || invoice.pay_amount === 0) invoice.selected = true;
			else invoice.selected = false;

			this.calPayAmount();
		},
		inputReceivedAmount() {
			//if (!this.received_amount) return;

			//var selectedInvoices = this.invoices.filter(invoice => invoice.selected);
			if (this.selectedInvoices.length == 0) {
				this.$toast.warning('No selected items. Check invoice(s) first.');
				return;
			} //console.log('received amount', this.received_amount);

			var remaining_amount = this.received_amount;

			this.selectedInvoices.forEach(function(invoice) {
				if (remaining_amount > 0) {
					if (remaining_amount > invoice.balance) invoice.pay_amount = invoice.balance;
					else invoice.pay_amount = remaining_amount;
					remaining_amount -= invoice.balance;
				} else {
					invoice.pay_amount = null;
				}
				// if (invoice.balance) {
				// 	invoice.selected = vm.allSelected;
				// 	vm.selectCheckBox(invoice);
				// }
			});
			this.calPayAmount();
		},
		blurReceivedAmount() {
			this.invoices.forEach(function(invoice) {
				//console.log(invoice.pay_amount);
				if (invoice.pay_amount) {
					//console.log('1');
					invoice.selected = true;
				} else {
					//console.log('2');
					invoice.selected = false;
				}
			});
		},
		selectAll() {
			//console.log(this.allSelected);
			var vm = this;
			this.invoices.forEach(function(invoice) {
				if (invoice.balance) {
					invoice.selected = vm.allSelected;
					vm.selectCheckBox(invoice);
				}
			});
		},
		selectInvoice(invoice) {
			if (invoice.invoice_type == 'B') {
				this.$router.push({ name: 'arCheck', params: {}, query: { bill_to_code: invoice.bill_to_code, check_no: invoice.bounce_invoice_info } });
			} else if (invoice.invoice_type == 'A') {
				return;
			} else {
				//this.$router.push({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: invoice.invoice_no } });
				let routeData = this.$router.resolve({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: invoice.invoice_no } });
				window.open(routeData.href, 'herp_invoice');
			}
		},
		selectSO(invoice) {
			//this.$router.push({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: invoice.invoice_no } });
			let routeData = this.$router.resolve({ name: 'soDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: invoice.invoice_no } });
			window.open(routeData.href, 'herp_so');
		},
		setPartner(partner) {
			this.bill_to_name = partner.name;
			this.search();
		},
		reset() {
			// this.sort_key = 'code';
			// this.sort_direction = 'ASC';

			this.invoice_date_from = this.user.company_id === 'minkhair' ? null : daysAgo(365);
			this.invoice_date_to = null;
			this.sales_group_code = null;
			this.bill_to_code = null;
			this.keyword = null;
			this.elapsed_days = null;
		},
		async excel() {
			if (this.invoices.length < 1) {
				this.$toast.error('No Data to Export.');
				return false;
			}

			let { data } = await apiSelectArList(this.saveParam);
			let invoices = data.arList;

			invoices.forEach(inv => {
				if (inv.elapsed_days < 31) inv.elapsed_period = 'Under 30 Days';
				else if (inv.elapsed_days < 61) inv.elapsed_period = '31 - 60 Days';
				else if (inv.elapsed_days < 91) inv.elapsed_period = '61 - 90 Days';
				else if (inv.elapsed_days < 121) inv.elapsed_period = '91 - 120 Days';
				else if (inv.elapsed_days < 151) inv.elapsed_period = '121 - 150 Days';
				else if (inv.elapsed_days < 181) inv.elapsed_period = '151 - 180 Days';
				else inv.elapsed_period = 'Over 180 Days';

				let remark = inv.bounce_invoice_info || '';
				if (inv.invoice_type === 'A') remark += inv.remark;
				else if (inv.invoice_type === 'B') remark += '/' + inv.remark;
				inv.remark = remark;
			});

			const fileName = 'AR_DETAIL';
			const headers = [
				{ key: 'invoice_dn', name: 'Inv. No', width: 15, dataType: defaultDataType.string },
				{ key: 'invoice_type', name: 'Type', width: 5, dataType: defaultDataType.string },
				{ key: 'invoice_date', name: 'Inv. Date', width: 15, dataType: defaultDataType.string },
				{ key: 'so_dn', name: 'S/O No', width: 15, dataType: defaultDataType.string },
				{ key: 'so_date', name: 'S/O Date', width: 15, dataType: defaultDataType.string },
				{ key: 'bill_to_code', name: 'Bill To Code', width: 15, dataType: defaultDataType.string },
				{ key: 'bill_to_name', name: 'Bill To Name', width: 15, dataType: defaultDataType.string },
				{ key: 'ship_to_state', name: 'Ship To State', width: 15, dataType: defaultDataType.string },
				{ key: 'sales_group_name', name: 'Sales Group', width: 15, dataType: defaultDataType.string },
				{ key: 'payment_term_code', name: 'Payment Term', width: 15, dataType: defaultDataType.string },
				{ key: 'past_due_date', name: 'Past Due Date', width: 15, dataType: defaultDataType.currency },
				{ key: 'invoice_amount', name: 'Inv. Amt.', width: 15, dataType: defaultDataType.number },
				{ key: 'balance', name: 'Balance', width: 15, dataType: defaultDataType.number },
				{ key: 'elapsed_period', name: 'Elapsed Days', width: 15, dataType: defaultDataType.string },
				{ key: 'remark', name: 'Info.(Bounce, SC & etc.)', width: 30, dataType: defaultDataType.string },
			];

			exportDataExcel(invoices, headers, fileName);
		},
		search() {
			this.cart_yn = 'N';
			this.page_no = 1;
			this.selectArs();
		},
		async selectArs() {
			// if (!this.bill_to_code && !this.sales_group_code) {
			// 	this.$toast.error('Both Bill To And Sales Group Are Empty');
			// 	return;
			// }

			//this.invoices = [];
			// this.selectedInvoice = {};
			// this.receipt_ars = [];
			// this.selectedArReceipt = {};
			this.allSelected = false;
			this.received_amount = null;
			this.pay_amount_sum = null;

			if (this.bill_to_code) this.paging_yn = 'N';
			else this.paging_yn = 'Y';

			let param = {
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),

				invoice_date_from: this.invoice_date_from,
				invoice_date_to: this.invoice_date_to,
				bill_to_code: this.bill_to_code,
				sales_group_code: this.sales_group_code,
				outstanding_yn: this.outstanding_yn,
				cart_yn: this.cart_yn,

				keyword: this.keyword,

				sort_key: 'invoice_date',
				sort_direction: 'ASC',

				exclude_post_check_amount: true,
				exclude_void: true,

				elapsed_days: this.elapsed_days,
			};

			this.saveParam = {
				paging_yn: 'N',

				invoice_date_from: param.invoice_date_from,
				invoice_date_to: param.invoice_date_to,
				bill_to_code: param.bill_to_code,
				sales_group_code: param.sales_group_code,
				outstanding_yn: param.outstanding_yn,
				cart_yn: param.cart_yn,

				keyword: param.keyword,

				sort_key: param.sort_key,
				sort_direction: param.sort_direction,

				exclude_post_check_amount: param.exclude_post_check_amount,
				exclude_void: param.exclude_void,

				elapsed_days: param.elapsed_days,
			};

			if (this.bounce_check) {
				param.bounce_check = true;
				this.saveParam.bounce_check = true;
			}

			const { data } = await apiSelectArList(param);
			//console.log(data);
			this.invoices = data.arList;
			this.list_count = data.list_count;
			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);

			var uri = '/receipt/ar_main?page_no=' + this.page_no;
			if (this.outstanding_yn) uri += '&outstanding_yn=' + this.outstanding_yn;
			if (this.invoice_date_from) uri += '&invoice_date_from=' + this.invoice_date_from;
			if (this.invoice_date_to) uri += '&invoice_date_to=' + this.invoice_date_to;
			if (this.sales_group_code) uri += '&sales_group_code=' + this.sales_group_code;
			if (this.bill_to_code) uri += '&bill_to_code=' + this.bill_to_code;
			if (this.cart_yn) uri += '&cart_yn=' + this.cart_yn;
			if (this.keyword) uri += '&keyword=' + this.keyword;
			/////this.$router.replace(uri).catch(err => err);
			this.uri = uri;
			window.history.pushState({}, null, uri);
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectArs();
		},
		gotoPartner(code) {
			this.$router.push({ name: 'partnerDetail', params: { mode: 'detail' }, query: { backUri: this.uri, code: code } });
		},
		async index() {
			const { data } = await apiIndex();

			this.salesGroups = data.salesGroupList;
		},
		async init() {
			this.reset();
			await this.index();

			if (this.$route.query.outstanding_yn) this.outstanding_yn = this.$route.query.outstanding_yn;
			if (this.$route.query.invoice_date_from) this.invoice_date_from = this.$route.query.invoice_date_from;
			if (this.$route.query.invoice_date_to) this.invoice_date_to = this.$route.query.invoice_date_to;
			if (this.$route.query.sales_group_code) this.sales_group_code = this.$route.query.sales_group_code;
			if (this.$route.query.bill_to_code) this.bill_to_code = this.$route.query.bill_to_code;
			if (this.$route.query.cart_yn) this.cart_yn = this.$route.query.cart_yn;
			if (this.$route.query.keyword) this.keyword = this.$route.query.keyword;
			if (this.$route.query.page_no) this.page_no = this.$route.query.page_no;

			await this.selectArs(this.$route.query.page_no);
		},
	},
	created() {
		//this.$store.sideIndex = 3;
		this.$store.commit('setSideIndex', 5);
		//this.$store.selectedMenu = 'nav_li_6';
		this.$store.commit('setSelectedMenu', 'nav_li_ar_main');
		this.$store.commit('setSubTitle', 'Accounting -> Accounts Receivable');

		//this.selectInvoices();
		this.init();

		//this.invoice.invoice_date = this.$moment(new Date()).format('MM-DD-YYYY');
		//this.invoice.so_date = today();
		//console.log(this.$moment(new Date()).format('MM-DD-YYYY HH:mm:ss'));

		//console.log(this.$session.get('time_zone'));
		//this.$moment.tz.setDefault(this.$session.get('time_zone'));
	},
	mounted() {
		inputSelectOnClick();

		if (this.user.company_id == 'newjigu') this.$refs.bill_to_code.$refs.keyword.focus();
	},
};
</script>

<style></style>
